import { lightTheme } from '@/customTheme'

function SpotlightIcon({ size = 24, fill = lightTheme.colors.blackGray }: { size?: number; fill?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        stroke={fill}
        strokeWidth={1.8}
        strokeLinecap="round"
        d="M15.295 19.5605L15.9999 21.9984M16.9998 15.999L20.7574 18.097M18.9996 12.4994L22.0253 11.9014M8.00088 8.99911V1.99922M7.61089 6.29919C6.9154 5.97262 6.12112 5.9254 5.39184 6.16728C4.66256 6.40916 4.05389 6.92168 3.69134 7.59917L2.3115 10.3891C1.98796 11.0836 1.94237 11.8756 2.18407 12.6026C2.42576 13.3296 2.93643 13.9366 3.61135 14.2991L10.5006 17.896C10.618 17.9548 10.7459 17.9899 10.8769 17.9992C11.0079 18.0086 11.1395 17.992 11.2641 17.9505C11.3887 17.909 11.5039 17.8434 11.6031 17.7573C11.7024 17.6713 11.7837 17.5665 11.8424 17.449L14.948 11.2381C15.0665 11.001 15.0859 10.7266 15.0021 10.4751C14.9183 10.2237 14.7381 10.0158 14.5011 9.89713L7.61089 6.29919Z"
      />
    </svg>
  )
}

export default SpotlightIcon
